export default __webpack_public_path__ + "static/media/public-onboarding-gif.e45fd62f.gif";